import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-752c9811")

_pushScopeId("data-v-752c9811")
const _hoisted_1 = { class: "flex" }
const _hoisted_2 = {
  key: 0,
  class: "selected"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "flex-1" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode("更 多")
const _hoisted_5 = { class: "padding-10" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", null, "图片展示列数", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_card_steps = _resolveComponent("card-steps")
  const _component_el_affix = _resolveComponent("el-affix")
  const _component_el_image = _resolveComponent("el-image")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_badge = _resolveComponent("el-badge")
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")
  const _component_el_slider = _resolveComponent("el-slider")
  const _component_el_drawer = _resolveComponent("el-drawer")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_el_affix, { offset: 0 }, {
      default: _withId(() => [
        _createVNode(_component_card_steps, {
          simple: "",
          width: "100%",
          "keyword-id": _ctx.$route.params.id,
          status: {
      preSelect: 'success',
      crop: _ctx.pageStatus.find(p => p.selectedCount > 0) ? 'progress' : 'wait'
    }
        }, null, 8, ["keyword-id", "status"])
      ]),
      _: 1
    }),
    _createVNode("div", _hoisted_1, [
      _createVNode("div", {
        class: "list",
        style: {columnCount: _ctx.columns}
      }, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.images, (image) => {
          return (_openBlock(), _createBlock("div", {
            key: image.pexelsImageInfo.photoModalMediumId,
            class: "list-item"
          }, [
            _createVNode(_component_el_image, {
              onClick: ($event: any) => (_ctx.selectImage(image)),
              src: image.pexelsImageInfo.photoModalImageGridItemSrc
            }, null, 8, ["onClick", "src"]),
            (image.selected)
              ? (_openBlock(), _createBlock("div", _hoisted_2, [
                  _createVNode(_component_el_button, {
                    onClick: ($event: any) => (_ctx.selectImage(image)),
                    type: "success",
                    circle: "",
                    icon: "el-icon-check"
                  }, null, 8, ["onClick"])
                ]))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ], 4),
      _hoisted_3,
      _createVNode("div", null, [
        _createVNode(_component_el_affix, { offset: 40 }, {
          default: _withId(() => [
            _createVNode(_component_el_button, {
              class: "margin-left-10",
              round: "",
              type: "warning",
              size: "small",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.infoPanelVisible = true))
            }, {
              default: _withId(() => [
                _hoisted_4
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_affix, { offset: 70 }, {
          default: _withId(() => [
            _createVNode(_component_el_scrollbar, { class: "full-height" }, {
              default: _withId(() => [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.pageStatus, (item) => {
                  return (_openBlock(), _createBlock("div", {
                    class: "margin-10",
                    key: item.pageNum,
                    onClick: ($event: any) => (_ctx.changePage(item.pageNum))
                  }, [
                    _createVNode(_component_el_badge, {
                      type: _ctx.currPageNum === item.pageNum ? 'primary' : item.status === 'PRE_SELECTED_DONE' ? 'success' : 'info',
                      value: item.selectedCount > 0 ? item.selectedCount : ''
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_button, {
                          round: "",
                          type: _ctx.currPageNum === item.pageNum ? 'primary' : item.status === 'PRE_SELECTED_DONE' ? 'success' : 'info',
                          size: "small"
                        }, {
                          default: _withId(() => [
                            _createTextVNode("第" + _toDisplayString(item.pageNum) + "页", 1)
                          ]),
                          _: 2
                        }, 1032, ["type"])
                      ]),
                      _: 2
                    }, 1032, ["type", "value"])
                  ], 8, ["onClick"]))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_el_drawer, {
      title: "更多信息",
      modelValue: _ctx.infoPanelVisible,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.infoPanelVisible = $event)),
      direction: "rtl"
    }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_5, [
          _hoisted_6,
          _createVNode(_component_el_slider, {
            modelValue: _ctx.columns,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.columns = $event)),
            max: "10",
            step: 1,
            "show-stops": ""
          }, null, 8, ["modelValue"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
})